import api from './api';

class OmieAuthService {

// Buscar empresas/organizações do usuário usando o endpoint do back-end
static async testConnectionOmie(params) {
    try {

        const response = await api.post(`/omie/test-integration`, params); // <-- params direto!

      if (response.status === 200) {
        return {
          success: response.data?.data?.status,
          integrations: response.data?.data?.data,
          message: response.data?.message ?? response.data?.data?.data?.message ?? response.data?.data?.message,
          razao_social: response.data?.data?.data?.razao_social,
          sync: response.data?.sync || null
        };
      } else {
        throw new Error(`Erro ao testar conexão com o Omie: status ${response.status}`);
      }
    } catch (error) {
      console.error('Erro ao testar conexão com o Omie:', error);
      throw new Error('Não foi possível testar a conexão com o Omie. Tente novamente.');
    }
  }

static async updateIsConfiguredOmie(payload) {
  try {
    const response = await api.post(`/sync/updateIsConfigured`, payload);
    if (response.status === 200) {
        return response.data;
    } else {
        throw new Error(`Erro ao atualizar o status de configuração do Omie: status ${response.status}`);
    }
  } catch (error) {
    console.error('Erro ao atualizar o status de configuração do Omie:', error);
    throw new Error('Não foi possível atualizar o status de configuração do Omie. Tente novamente.');
  }
}
}

export default OmieAuthService;
